import { footerTheme } from 'themes/jumbo/app/_themes/footer/semi-dark';
import { headerTheme } from 'themes/jumbo/app/_themes/header/semi-dark';
import { mainTheme } from 'themes/jumbo/app/_themes/main/semi-dark';
import { sidebarTheme } from 'themes/jumbo/app/_themes/sidebar/semi-dark';
import { footerTheme as footerTheme_light } from 'themes/jumbo/app/_themes/footer/default';
import { headerTheme as headerTheme_light } from 'themes/jumbo/app/_themes/header/default';
import { mainTheme as mainTheme_light } from 'themes/jumbo/app/_themes/main/default';
import { sidebarTheme as sidebarTheme_light } from 'themes/jumbo/app/_themes/sidebar/default';
import { JumboThemeConfig } from 'themes/jumbo/@jumbo/types';
import { createJumboTheme } from 'themes/jumbo/@jumbo/utilities/helpers';

type ConfigType = {
  THEME: JumboThemeConfig;
};

const isLigthTheme = localStorage.getItem('selectedTheme') === 'light';
export const CONFIG: ConfigType = {
  THEME: createJumboTheme(
    isLigthTheme ? mainTheme_light : mainTheme,
    isLigthTheme ? headerTheme_light : headerTheme,
    isLigthTheme ? sidebarTheme_light : sidebarTheme,
    isLigthTheme ? footerTheme_light : footerTheme
  )
};
